import React from 'react';
import { CheckCircle2, AlertTriangle, XCircle, Info, Circle } from 'lucide-react';
import { cn } from '../utils/cn';
import { toneForStatus, humanizeStatus, TONE_CLASSES, type Tone } from '../utils/statusTone';

export interface ILMSStatusBadgeProps {
  status: string;
  tone?: Tone;
  className?: string;
  size?: 'sm' | 'md';
}

const TONE_ICON: Record<Tone, React.ComponentType<{ className?: string }>> = {
  success: CheckCircle2,
  warning: AlertTriangle,
  critical: XCircle,
  info: Info,
  neutral: Circle,
};

/** Reusable status pill: color + icon + text, used for animal/payment/treatment/approval/meter/notification status. */
export function ILMSStatusBadge({ status, tone, className, size = 'md' }: ILMSStatusBadgeProps) {
  const resolvedTone = tone ?? toneForStatus(status);
  const classes = TONE_CLASSES[resolvedTone];
  const Icon = TONE_ICON[resolvedTone];
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full border font-medium whitespace-nowrap',
        classes.bg,
        classes.text,
        classes.border,
        size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-2.5 py-1 text-sm',
        className
      )}
    >
      <Icon className={size === 'sm' ? 'h-3 w-3' : 'h-3.5 w-3.5'} aria-hidden="true" />
      {humanizeStatus(status)}
    </span>
  );
}
